import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/apis";
import { sagaFunctions } from "../../config/helper";
import {
  Customer,
  Customers,
  GetMarketing,
  GetProdsFromExcel,
  Marketing,
  Orders,
  Products,
  SyncOmniData,
  UploadExcel,
  UploadProdImg,
  Origins
} from "./Action";

function customers(req) {
  const isAdmin = req.payload.isAdmin
  delete req.payload.isAdmin
  return sagaFunctions(Customers, "get", isAdmin ? apis.admin.admins : apis.admin.customers, req.payload)();
}
function customer(req) {
  let id = req.payload.id;
  delete req.payload.id;
  return sagaFunctions(
    Customer,
    "get",
    apis.admin.customers + "/" + id,
    req.payload
  )();
}

function orders(req) {
  return sagaFunctions(Orders, "get", apis.admin.orders, req.payload)();
}

function products(req) {
  return sagaFunctions(Products, "get", apis.admin.orders, req.payload)();
}

function syncOmniUsers(req) {
  return sagaFunctions(
    SyncOmniData,
    "get",
    apis.admin.sync_omni_users,
    req.payload
  )();
}

function get_marketing(req) {
  return sagaFunctions(
    GetMarketing,
    "get",
    apis.admin.admin_marketing,
    req.payload
  )();
}

function products_from_excel(req) {
  return sagaFunctions(
    GetProdsFromExcel,
    "get",
    apis.admin.export_excel,
    req.payload,
    {},
    true
  )();
}

function upload_product_img(req) {
  return sagaFunctions(
    UploadProdImg,
    "post",
    apis.admin.uploadImgs + "?admin=true",
    req.payload,
    {
      "Content-Type": "multipart/form-data",
    }
  )();
}

function marketing(req) {
  let params = {
    email: localStorage.getItem("email")
  }
  return sagaFunctions(
    Marketing,
    "post",
    apis.admin.admin_marketing + `?admin=true&email=${params.email}`,
    req.payload,
    {
      "Content-Type": "multipart/form-data",
    }
  )();
}

function origin() {
  let params = {
    email: localStorage.getItem("email")
  }
  return sagaFunctions(
    Origins,
    "get",
    apis.origins, params
  )();
}

function upload_excel(req) {
  let params = {
    email: req.payload.email,
  };
  delete req.payload.email;
  delete req.payload.token;
  return sagaFunctions(
    UploadExcel,
    "post",
    apis.admin.import_excel,
    req.payload,
    {
      "Content-Type": "multipart/form-data",
      params,
    }
  )();
}

export function* adminWatcher() {
  yield takeLatest(Orders.REQUEST, orders);
  yield takeLatest(Origins.REQUEST, origin);
  yield takeLatest(SyncOmniData.REQUEST, syncOmniUsers);
  yield takeLatest(Products.REQUEST, products);
  yield takeLatest(Customers.REQUEST, customers);
  yield takeLatest(Customer.REQUEST, customer);
  yield takeLatest(UploadExcel.REQUEST, upload_excel);
  yield takeLatest(GetProdsFromExcel.REQUEST, products_from_excel);
  yield takeLatest(UploadProdImg.REQUEST, upload_product_img);
  yield takeLatest(Marketing.REQUEST, marketing);
  yield takeLatest(GetMarketing.REQUEST, get_marketing);
}
